/**
 * Permissions API Detector
 */

export interface PermissionsResult {
  queriedCount: number;
}

export async function detectPermissions(): Promise<PermissionsResult> {
  try {
    if (!navigator.permissions) {
      return { queriedCount: 0 };
    }

    const permissionsToCheck = [
      'geolocation',
      'notifications',
      'camera',
      'microphone',
    ];

    let count = 0;
    for (const permission of permissionsToCheck) {
      try {
        await navigator.permissions.query({ name: permission as PermissionName });
        count++;
      } catch {
        // Permission not supported, skip
      }
    }

    return { queriedCount: count };
  } catch (error) {
    return { queriedCount: 0 };
  }
}
